import { BaseModel } from './base.model';

export class SatisfactionSurveyQuestion extends BaseModel {
    id?: string;
    description?: string;
    answerType?: number;
    choiceType?: number;
}